// @flow

// async actions for notes
export default {
  /**
   * Helper to set the entire recipe into scaled mode with updated
   * meta data and ingredient quantities.
   *
   * Assumes data is already in cache
   */
  scaleRecipe({ state, commit }: ArticleAction) {
    if (state.cache && state.cache.scaledMetaData && state.cache.scaledIngredients) {
      commit('updateMetaData', state.cache.scaledMetaData)
      commit('setIngredients', state.cache.scaledIngredients)
      commit('setMode', 'scaled')
    }
  },

  /**
   * Helper to revert the un-scale / revert the recipe back to original
   * data.
   *
   * Assumes original data is already in cache.
   */
  resetRecipe({ state, commit }: ArticleAction) {
    if (state.cache && state.cache.originalMetaData) {
      commit('updateMetaData', state.cache.originalMetaData)

      // clear out ingredients and the getter getScaledIngredients
      // will simply return the original ingredients
      commit('setIngredients', {})

      // toggle mode
      commit('setMode', 'original')
    }
  },
}
